export default __webpack_public_path__ + "static/media/BURNT.02f52a06.svg";